<template>
  <el-card style="margin: 4px;"  v-loading="dists == null || levels == null" shadow="hover">
    <div slot="header" class="clearfix top">
      <div class="flex topBar">
        <span class="mgra">Distribution Lists</span>
        <el-button icon="el-icon-plus" size="small" @click="newDist" />
      </div>
    </div>
    <el-table
      v-if="dists && levels"
      height="400"
      :data="dists"
      @selection-change="handleSelectionChange"
      @cell-click="editDist"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="Name" prop="name" min-width="100" />
      <el-table-column label="AD Group" prop="ad_group" min-width="100" />
      <el-table-column label="Levels" prop="member_levels" min-width="100">
        <template slot-scope="scope">
          <el-tag v-for="level in scope.row.member_levels" :key="level.o_id" size="mini">{{level.name}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottom clearfix">
      <el-popover
        v-if="selectedObjects.length != 0"
        v-model="del_visible"
        placement="top"
        width="160"
      >
        <p>Are you sure?</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="del_visible=false">Cancel</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="selectedObjects.forEach((event) => {deleteDist(event);})"
          >Delete</el-button>
        </div>
        <el-button slot="reference" icon="el-icon-delete" type="danger" size="small"></el-button>
      </el-popover>
    </div>
    <el-dialog
      :title="`${!tempDist.new ? 'Edit' : 'New'} Distribution List`"
      :visible.sync="dialogVisible"
      :fullscreen="$mq === 'xs'"
      width="60%"
      :close="closeModal"
    >
      <el-form ref="distForm" :rules="rules" :model="tempDist">
        <el-form-item label="Name" prop="name">
          <el-input type="name" v-model="tempDist.name"></el-input>
        </el-form-item>
        <el-form-item label="AD Group" prop="ad_group">
          <el-input type="name" v-model="tempDist.ad_group"></el-input>
        </el-form-item>
        <el-form-item label="Webhook URL" prop="slack_webhook_url">
          <el-input type="name" v-model="tempDist.slack_webhook_url"></el-input>
        </el-form-item>
        <el-form-item label="Levels" prop="member_levels">
          <el-select
            multiple
            v-model="tempDist.member_levels"
            placeholder="Select Levels"
            value-key="o_id"
          >
            <el-option
              v-for="item in levels"
              :key="item.o_id"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModal">Cancel</el-button>
        <el-button type="primary" @click="saveDist">Save</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<style scoped>
.topBar {
  align-items: center;
}
.button {
  margin: 4px;
  margin-right: 8px;
  margin-bottom: 0px;
  padding: 8px;
  padding-bottom: 0px;
  float: right;
}
.bottom {
  line-height: 12px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>

<script>
import {mapFields} from "vuex-map-fields";
export default {
    data() {
        return {
            locked: true,
            dialogVisible: false,
            del_visible: false,
            dists: null,
            selectedObjects: [],
            tempDist: {},
            distTemplate:{
                "name": "",
                "ad_group": "",
                "slack_webhook_url": null,
                "member_levels": []
            },
            rules: {
                name: [
                    {required: true, message: "Please input name", trigger: "blur"}
                ]
            }
        };
    },
    computed: {...mapFields(["levels"])},
    watch: {},
    mounted() {
        if (this.levels == null) this.$store.dispatch("pullLevels");
        this.getDists();
    },
    methods: {
        handleSelectionChange(val) {
            this.$set(this, "selectedObjects", val);
        },
        newDist() {
            this.tempDist = JSON.parse(JSON.stringify(this.distTemplate));
            this.dialogVisible = true;
        },
        editDist(val) {
            this.tempDist = JSON.parse(JSON.stringify(val));
            this.dialogVisible = true;
        },
        closeModal() {
            this.dialogVisible = false;
            this.tempDist = JSON.parse(JSON.stringify(this.distTemplate));
        },
        getDists(){
            this.axios
                .get("/api/v1/distributionlists", {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.dists = response.data;
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.message,
                        type: "error"
                    });
                });
        },
        deleteDist(row) {
            this.axios
                .delete("/api/v1/distributionlists/" + row.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: "List deleted successfuly",
                        type: "success"
                    });
                    var temp = this.dists.find((objv) => objv.o_id == row.o_id);
                    var index = this.dists.indexOf(temp);
                    this.dists.splice(index, 1);
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.message,
                        type: "error"
                    });
                });
        },
        saveDist() {
            this.$refs.distForm.validate((valid) => {
                if (valid) {
                    var route = "";
                    if (this.tempDist.o_id) {
                        route = "/api/v1/distributionlists/" + this.tempDist.o_id;
                        this.axios
                            .put(route, {
                                name: this.tempDist.name,
                                ad_group: this.tempDist.ad_group,
                                slack_webhook_url: this.tempDist.slack_webhook_url,
                                member_levels: this.tempDist.member_levels.map((e) => e.o_id)
                            }, {
                                headers: {"Content-Type": "application/json"},
                                credentials: "same-origin"
                            })
                            .then((response) => {
                                this.dists.splice(
                                    this.dists.findIndex((e) => e.o_id == response.data.o_id),
                                    1,
                                    response.data
                                );
                                this.closeModal();
                                this.$message({
                                    showClose: true,
                                    message: "List saved successfuly.",
                                    type: "success"
                                });
                            })
                            .catch((err) => {
                                console.error(err);
                                this.$message({
                                    showClose: true,
                                    message: err.response.data.message,
                                    type: "error"
                                });
                            });
                    } else {
                        route = "/api/v1/distributionlists";
                        this.axios
                            .post(route, {
                                name: this.tempDist.name,
                                ad_group: this.tempDist.ad_group,
                                slack_webhook_url: this.tempDist.slack_webhook_url,
                                member_levels: this.tempDist.member_levels.map((e) => e.o_id)
                            }, {
                                headers: {"Content-Type": "application/json"},
                                credentials: "same-origin"
                            })
                            .then((response) => {
                                this.dists.push(response.data);
                                this.closeModal();
                                this.$message({
                                    showClose: true,
                                    message: "List created successfuly",
                                    type: "success"
                                });
                            })
                            .catch((err) => {
                                this.$message({
                                    showClose: true,
                                    message: err.response.data.message,
                                    type: "error"
                                });
                            });
                    }
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
